export const constants = {
  BASE_URL: 'https://raw.githubusercontent.com/xrochoa/photo-gallery-resources/master',
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants.js